<!-- Entity 组件是借鉴 ElementUI 的 ImageViewer 组件而实现的！-->
<template>
    <!-- 监听由子组件 Carsousel 发出的 spacing 事件，用来调整 prev/next popupingEntity button 位置的 -->
    <transition name="viewer-fade">
        <!-- 注意，之前这里的 zIndex 传入的是 2000+，导致 ElementUI 的 tooltip 直接不能显示，List 传入的时候改成 200 好了-->
        <div tabindex="-1"
             ref="el-image-viewer__wrapper"
             class="el-image-viewer__wrapper"
             style="font-size:14px;"
             :style="{ 'z-index': zIndex, '--spacing': spacing }" >
            <div class="el-image-viewer__mask" @click.self="handleMaskClick"></div>
            <!-- CLOSE -->
            <span class="el-image-viewer__btn el-image-viewer__close" @click="hide">
                <i class="el-icon-close"></i>
            </span>
            <!-- ARROW: next/prev popupingEntity arrow button -->
            <span class="el-image-viewer__btn el-image-viewer__prev" v-if="hasPrev_" @click="prev">
                <i class="el-icon-arrow-left"/>
            </span>
            <span class="el-image-viewer__btn el-image-viewer__next" v-if="hasNext_" @click="next">
                <i class="el-icon-arrow-right"/>
            </span>
            <div class="el-image-viewer__canvas" style="overflow: scroll;">
                <!-- 以下注释掉的是，使用单图调试时候的方式，不要删除！很重要！ -->
                <!--
                <img
                    class="el-image-viewer__img"
                    :src="require('@/assets/entries/CK_6XP8H9Jx/2503976602201739889_3.jpg')"
                    style="transform: scale(1) rotate(0deg); margin-left: 0px; margin-top: 0px; max-height: 100%; max-width: 100%;"
                >
                -->
                <!-- 填充 Entity -->
                <entity v-bind="$attrs" @spacing="spacingCtr"/>
            </div>
        </div>
    </transition>
</template>

<script>

    import Entity from './Entity'
    import {isHybridAgent, isPhoneAgent, Styles} from "../../utils";

    export default {
        name: "PopupEntity",
        components: {
            Entity
        },
        props: {
            // indicates if has previous popupingEntity
            hasPrev: {
                type: Boolean,
                default: true
            },
            // indicates if has previous popupingEntity
            hasNext: {
                type: Boolean,
                default: true
            },
            zIndex: {
                type: Number,
                default: 10
            },
            // 用户传递的回调方法
            closeHandler: {
                type: Function,
                default: () => {}
            },
            prevEntityHandler: {
                type: Function,
                default: () => {}
            },
            nextEntityHandler: {
                type: Function,
                default: () => {}
            }
        },
        created() {
            // FIX for HCF327 - 手机端在用户中心喜欢/收藏的弹出 entity 页面中，点击 profile name 路由到 profile 页面，弹出窗口不关闭
            // Update 2021/11/26, 改成了 hybrid agent，因为 ipad 也存在这样的问题
            if(isHybridAgent()) {
                this.$EventBus.$on('closepopups', () => { this.hide() } );
            }
        },
        beforeDestroy() {
            if(isHybridAgent()){
                this.$EventBus.$off('closepopups');
            }
        },
        data() {
            return {
                spacing: '0px', // 控制 next/previous popupingEntity 按钮和关闭按钮距屏幕的距离，否则这些按钮在小尺寸下将会被弹出框遮蔽。
                hasPrev_: this.hasPrev,
                hasNext_: this.hasNext
            }
        },
        methods: {
            handleMaskClick(){

            },
            hide() {
                this.closeHandler();
                Styles.enableBodyScroll();
            },
            // 触发 prev popupingEntity
            prev() {
                this.prevEntityHandler();
            },
            // 触发 next popupingEntity
            next() {
                this.nextEntityHandler();
            },
            // 控制 next/prev 按钮和 close 按钮与屏幕的间距，事件由 Carsousel 发出
            spacingCtr(spacing) {
                this.spacing = spacing+'px';
            }
        }
    }
</script>

<style scoped>

    :root {
        --spacing: 0px;  /* 控制 next/previous popupingEntity 按钮和关闭按钮距屏幕的距离 */
    }

    /* 动态设置 next popupingEntity button 和屏幕的间距 */
    .el-image-viewer__next{
        right: var(--spacing)
    }

    .el-image-viewer__prev{
        left: var(--spacing)
    }

    .el-image-viewer__close{
        top: var(--spacing);
        right: var(--spacing);
        z-index: 3000;
    }


    /* Mobile and Pad 的尺寸 */
    @media (max-width: 735px) {

        /deep/ .el-image-viewer__canvas {
            display: block; /* 使得 Carsousel 和 Infoboard 是上下排列的 */
        }

        /* 移动尺寸下，prev/next popupingEntity btn 不再显示 */
        .el-image-viewer__next {
            display: none;
        }

        .el-image-viewer__prev {
            display: none;
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/entity/PopupEntity.vue